import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo-second.png'


const _withScopeId = n => (_pushScopeId("data-v-dd0798f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-white\" data-v-dd0798f0><div class=\"bg-main text-center py-10\" data-v-dd0798f0><p class=\"px-sm-5 display-5 fw-bold\" data-v-dd0798f0> La página que estas buscando no existe </p><div class=\"my-5\" data-v-dd0798f0><a class=\"btn btn-info my-5\" href=\"https://afiliados.juntoz.com/\" data-v-dd0798f0><span data-v-dd0798f0>Ir a la página principal <i class=\"fas fa-external-link-alt\" data-v-dd0798f0></i></span></a></div></div></div>", 1)
const _hoisted_2 = {
  class: "container-fluid px-sm-20 pt-10 pb-5 text-white",
  style: {"background":"#1a0b21"}
}
const _hoisted_3 = { class: "text-white" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 offset-md-1 mb-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "px-sm-10" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "",
        width: "222",
        height: "80",
        class: "d-inline-block align-text-top"
      })
    ])
  ])
], -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-sm-6\" data-v-dd0798f0><div class=\"col-md-4 offset-md-1 mb-3 m-0\" data-v-dd0798f0><div class=\"py-5 px-sm-10\" data-v-dd0798f0><ul class=\"list-unstyled d-flex m-0\" data-v-dd0798f0><li class=\"ms-sm-3\" data-v-dd0798f0><a class=\"\" href=\"https://www.facebook.com/JuntozOficialPe/\" target=\"_blank\" data-v-dd0798f0><i class=\"bi bi-facebook text-white\" data-v-dd0798f0></i></a></li><li class=\"ms-5\" data-v-dd0798f0><a class=\"\" href=\"https://www.instagram.com/juntozoficialpe/\" target=\"_blank\" data-v-dd0798f0><i class=\"bi bi-instagram text-white\" data-v-dd0798f0></i></a></li><li class=\"ms-5\" data-v-dd0798f0><a class=\"\" href=\"https://www.youtube.com/juntozoficial\" target=\"_blank\" data-v-dd0798f0><i class=\"bi bi-youtube text-white\" data-v-dd0798f0></i></a></li><li class=\"ms-5\" data-v-dd0798f0><a class=\"\" href=\"https://api.whatsapp.com/send/?phone=51015007899&amp;text&amp;app_absent=0\" target=\"_blank\" data-v-dd0798f0><i class=\"bi bi-whatsapp text-white\" data-v-dd0798f0></i></a></li></ul></div></div></div>", 1)
const _hoisted_7 = { class: "col-12 col-sm-6" }
const _hoisted_8 = { class: "d-flex justify-content-start justify-content-sm-end" }
const _hoisted_9 = { class: "ms-5" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Términos y condiciones y políticas de privacidad")
const _hoisted_11 = {
  class: "d-flex flex-column flex-sm-row justify-content-center py-4",
  style: {"background":"#8038a7"}
}
const _hoisted_12 = { class: "m-0 text-white text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("footer", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_router_link, {
                  to: "/terminos-y-condiciones",
                  class: "text-white font-16"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("p", _hoisted_12, " © " + _toDisplayString($setup.currentYear) + " Juntoz | Todos los derechos reservados. ", 1)
    ])
  ], 64))
}